export enum INTEGRATION {
    SEMRUSH = 'SEMRUSH',
    WINMO = 'WINMO',
}
